const NoContentPage = () => {
  return (
    <div className="flex p-20 justify-content items-center">
      NO CONTENT FOUND
    </div>
  );
};

export default NoContentPage;